import { mountTecmojoWidget, type TecmojoWidgetConfig } from "./bootstrap";

declare global {
  interface Window {
    /** Set before loading the embed script (see Shopify snippet). */
    TECMOJO_WIDGET_CONFIG?: TecmojoWidgetConfig;
  }
}

function readConfig(): TecmojoWidgetConfig | null {
  const cfg = window.TECMOJO_WIDGET_CONFIG;
  if (!cfg?.apiBaseUrl?.trim()) {
    console.warn(
      "[TecmojoWidget] Missing window.TECMOJO_WIDGET_CONFIG.apiBaseUrl — widget not mounted.",
    );
    return null;
  }
  return cfg;
}

function boot() {
  const cfg = readConfig();
  if (!cfg) {
    return;
  }
  mountTecmojoWidget({
    apiBaseUrl: cfg.apiBaseUrl.trim(),
    title: cfg.title,
    mountSelector: cfg.mountSelector,
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}

export { mountTecmojoWidget, type TecmojoWidgetConfig };
